var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 搜索框
 * @author (v_lichaoqing)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash-es';
import classnames from 'classnames';

import Input from '../Input';
import { classPrefix } from '../../common/util';

import './Search.less';

/*
 * 参数说明
 * value             可选，input的值
 * iconClick         可选，搜索icon的点击事件，设置此项时，icon会有hover态，否则没有hover态
 * placeHolder       可选，input的placeHolder
 * className         可选, 元素追加类名
 * width             可选，设置宽度
 * disabled          可选，input的disabled状态
 * maxLength         可选，input最大可输入值的长度，超过最大长度时，输入框变红
 * circular          可选，true圆角， false时不是圆角
 * onPressEnter      可选，按回车键执行的函数
 * countFlag         可选，数字提示
 * classPrefix       可选，类名前缀
 */

var Search = function (_Component) {
    _inherits(Search, _Component);

    function Search(props) {
        _classCallCheck(this, Search);

        var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

        _this.getValue = function (obj) {
            var getValue = _this.props.getValue;
            if (_.isFunction(getValue)) {
                getValue(obj);
            }
        };

        _this.onKeyDown = function (e) {
            if (e.keyCode === 13 && _this.props.onPressEnter) {
                _this.props.onPressEnter(e);
            }
        };

        _this.iconHover = function (e) {
            var iconHover = void 0;
            if (e.type === 'mouseenter') {
                iconHover = true;
            } else if (e.type === 'mouseleave') {
                iconHover = false;
            }
            _this.setState({ iconHover: iconHover });
        };

        _this.cancelOnClick = function (e) {
            var _this$props = _this.props,
                cancelIcon = _this$props.cancelIcon,
                getValue = _this$props.getValue,
                name = _this$props.name,
                value = _this$props.value,
                iconClick = _this$props.iconClick;


            if (cancelIcon && value) {
                getValue({ name: name, value: '' });
            }

            if (cancelIcon && iconClick) {
                iconClick('', e);
            }
        };

        _this.state = {
            iconHover: false
        };
        return _this;
    }

    _createClass(Search, [{
        key: 'onClick',
        value: function onClick(e) {
            var _props = this.props,
                disabled = _props.disabled,
                iconClick = _props.iconClick,
                value = _props.value;

            if (disabled) {
                return;
            }
            if (iconClick) {
                iconClick(value, e);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames, _classnames2, _classnames3;

            var _props2 = this.props,
                placeHolder = _props2.placeHolder,
                className = _props2.className,
                disabled = _props2.disabled,
                width = _props2.width,
                circular = _props2.circular,
                maxLength = _props2.maxLength,
                value = _props2.value,
                noWarning = _props2.noWarning,
                countFlag = _props2.countFlag,
                classPrefix = _props2.classPrefix,
                noDistance = _props2.noDistance,
                height = _props2.height,
                name = _props2.name,
                onFocus = _props2.onFocus,
                onBlur = _props2.onBlur,
                cancelIcon = _props2.cancelIcon,
                iconClick = _props2.iconClick;

            var divStyleWidth = {};
            width && (divStyleWidth.width = parseFloat(width) + 'px');
            height && (divStyleWidth.height = parseFloat(height) + 'px');

            var hasCancelIcon = !disabled && cancelIcon && value && this.state.iconHover;
            var divClass = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-search-root', true), _defineProperty(_classnames, classPrefix + '-search-circular', circular), _defineProperty(_classnames, classPrefix + '-search-input-nowarning', noWarning), _defineProperty(_classnames, classPrefix + '-search-input-countflag', maxLength !== undefined && countFlag), _defineProperty(_classnames, classPrefix + '-search-width', width), _defineProperty(_classnames, className, className ? true : false), _classnames));
            var inputClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-search-disabled', disabled), _defineProperty(_classnames2, 'has-cancel-icon', hasCancelIcon), _classnames2));
            var iconClass = classnames((_classnames3 = {}, _defineProperty(_classnames3, classPrefix + '-search-icon', true), _defineProperty(_classnames3, classPrefix + '-search-icon-hover', !disabled && iconClick), _defineProperty(_classnames3, classPrefix + '-search-icon-disabled', disabled), _classnames3));
            var inputProps = {
                name: name,
                noDistance: noDistance,
                width: width,
                height: height,
                placeHolder: placeHolder,
                className: inputClass,
                disabled: disabled,
                onKeyDown: this.onKeyDown,
                max: maxLength,
                value: value,
                noWarning: noWarning,
                countFlag: countFlag,
                getValue: this.getValue,
                onFocus: onFocus,
                onBlur: onBlur
            };
            var iconProps = {
                className: iconClass,
                onClick: this.onClick.bind(this)
            };

            var iconCancelProps = {
                className: classnames(_defineProperty({}, classPrefix + '-search-icon-cancel', hasCancelIcon)),
                onClick: this.cancelOnClick
            };
            return React.createElement(
                'div',
                {
                    className: divClass,
                    style: _extends({}, divStyleWidth),
                    onMouseEnter: this.iconHover,
                    onMouseLeave: this.iconHover
                },
                React.createElement(Input, inputProps),
                React.createElement('div', iconCancelProps),
                React.createElement('div', iconProps)
            );
        }
    }]);

    return Search;
}(Component);

Search.propTypes = {
    value: PropTypes.string,
    getValue: PropTypes.func,
    iconClick: PropTypes.func,
    placeHolder: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    maxLength: PropTypes.number,
    circular: PropTypes.bool,
    onPressEnter: PropTypes.func,
    countFlag: PropTypes.bool,
    noWarning: PropTypes.bool,
    classPrefix: PropTypes.string,
    noDistance: PropTypes.bool,
    height: PropTypes.number,
    name: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    cancelIcon: PropTypes.bool
};
Search.defaultProps = {
    value: '',
    disabled: false,
    circular: true,
    noWarning: true,
    countFlag: false,
    classPrefix: classPrefix
};
export default Search;